import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-box" }
const _hoisted_2 = { class: "card card-outline card-primary" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header text-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "../../index2.html",
    class: "h1"
  }, [
    /*#__PURE__*/_createElementVNode("b", null, "Admin"),
    /*#__PURE__*/_createTextVNode("LTE")
  ])
], -1)
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<p class=\"login-box-msg\"> You forgot your password? Here you can easily retrieve a new password. </p><form><div class=\"input-group mb-3\"><input type=\"email\" class=\"form-control\" placeholder=\"Email\"><div class=\"input-group-append\"><div class=\"input-group-text\"><span class=\"fas fa-envelope\"></span></div></div></div><div class=\"row\"><div class=\"col-12\"><button type=\"submit\" class=\"btn btn-primary btn-block\"> Request new password </button></div></div></form>", 2)
const _hoisted_7 = { class: "mt-3 mb-1" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Login")

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("p", _hoisted_7, [
          _createVNode(_component_router_link, { to: "/login" }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}